module.exports = __webpack_public_path__ + "img/img1.4224306c.png";